import { splitIncludedDraftAllocationEvenly } from '@gonfalon/experiments/splitIncludedDraftAllocationEvenly';
import type { FeatureFlag } from '@gonfalon/flags/types';

import type { Flag } from '#utils/flags/records/Flag';

interface Variation {
  _id?: string;
  name?: string;
}

function processVariations(variations: Variation[], initialFlagKey: string) {
  return variations.map((variation, index, filteredVariations) => {
    const allocations = splitIncludedDraftAllocationEvenly(
      filteredVariations.map((v) => ({
        name: v.name ?? '',
        parameters: [{ flagKey: initialFlagKey, variationId: v._id ?? '' }],
        included: true,
        allocationPercent: 0,
      })),
    );
    return {
      baseline: index === 0,
      allocationPercent: allocations[index].allocationPercent.toString(),
      name:
        variation.name && variation.name !== '' ? variation.name : index === 0 ? 'Control' : `Treatment ${index + 1}`,
      parameters: [{ flagKey: initialFlagKey, variationId: variation._id ?? '' }],
    };
  });
}

export function transformFlagDataVariationsForExperimentCreation(flagData: FeatureFlag, initialFlagKey?: string) {
  if (!initialFlagKey) {
    return [];
  }
  const filteredVariations = flagData?.variations.filter((v) =>
    flagData._purpose === 'ai' ? v.name !== 'disabled' : true,
  );
  return processVariations(filteredVariations, initialFlagKey);
}

export function transformFlagVariationsForExperimentCreation(flag: Flag, initialFlagKey?: string) {
  if (!initialFlagKey) {
    return [];
  }
  const filteredVariations = flag?.variations
    .filter((v) => (flag._purpose === 'ai' ? v.name !== 'disabled' : true))
    .toJS();
  return processVariations(filteredVariations, initialFlagKey);
}
